import PropTypes from 'prop-types';
import '../../../styles/reports.css';
import React from 'react';
import { useGetViewStandardMutation } from '../../../../../features/authentication/reportApiSlice';
import Modals from '../../../../assignments/pages/ManageAssign/components/StudentSessionReport/components/Modals';
import { generateTableRows } from './generateTableRows';
import { generateTableHeaders } from './generateTableHeaders';

const PropertiesTable = ({
  header,
  data,
  persistData
}) => {

  const [getStandard] = useGetViewStandardMutation();
  const [openStandardModal, setOpenStandardModal] = React.useState(false);
  const [viewStandardDetails, setViewStandardDetails] = React.useState({});

  const handleStandard = async (standard) => {
    const option = {
      stateCourseId: parseInt(standard.stateCourseId),
      standardNumber: String(standard.standardNumber),
      stateId: standard.stateId
    };
    try {
      const { data } = await getStandard(option);
      setViewStandardDetails(data);
      setOpenStandardModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div id='growthTable' className='mt-4 table-responsive growth-table-scroll-bar'>
        <table className='w-100 text-center growth-table '>
          <thead>
            <tr>
              <th colSpan={persistData.midTestID > 0 ? 4 : 3} className='border'>{header}</th>
              {persistData.studentID > 0 &&
                generateTableHeaders('bg-student-header', persistData.growth, persistData.midTestID > 0)
              }
              {persistData.classID > 0 &&
                generateTableHeaders('bg-class-header', persistData.growth, persistData.midTestID > 0)
              }
              {persistData.teacherID > 0 &&
                generateTableHeaders('bg-teacher-header', persistData.growth, persistData.midTestID > 0)
              }
              {persistData.schoolID > 0 &&
                generateTableHeaders('bg-school-header', persistData.growth, persistData.midTestID > 0)
              }
              {persistData.districtID > 0 &&
                generateTableHeaders('bg-district-header', persistData.growth, persistData.midTestID > 0)
              }
            </tr>
          </thead>
          <tbody>
            {data.map((propertyItem, propertyIndex) => {
              var standard = {
                stateCourseId : propertyItem.standardsGroupId,
                standardNumber : propertyItem.id,
                stateId : propertyItem.stateId
              };
              return (
                <React.Fragment key={propertyIndex}>
                  <>
                    <tr>
                      <td colSpan={persistData.midTestID > 0 ? 4 : 3} className={`border ${header == 'Standards' ? 'text-decoration-underline cursor-pointer' : ''}`}
                        onClick={() => header == 'Standards' ? handleStandard(standard) : ''}>{propertyItem.name}</td>
                    </tr>
                    <tr>
                      <td className='rounded-0 border'>Pre-Test</td>
                      {persistData.midTestID > 0 &&
                        <td className='border'>Mid-Test</td>
                      }
                      <td className='border'>Post-Test</td>
                      <td className='border'>Score<br />Type</td>
                    </tr>
                  </>
                  {propertyItem.score.map((item, index) => {
                    var thresholdValue = item.scoreType == 'points' ? persistData.thresholdPoints : persistData.thresholdPercent;
                    var isPercent = item.scoreType == 'points' ? false : true;
                    var isMidTestEnabled = persistData.midTestID > 0;
                    return (
                      <React.Fragment key={index}>
                        {((persistData.points && item.scoreType == 'points') || (persistData.percentage && item.scoreType == 'percentage')) &&
                        <tr>
                          <td className='border'>
                            {propertyItem.preTestQuestionNos?.length > 0 && propertyItem.preTestQuestionNos?.map((qNo, index, arr) => {
                              return (
                                <span key={'preQ'+ index}>{qNo + `${index < arr.length - 1 ? ', ' : ''}`}</span>
                              );
                            })}
                          </td>
                          {isMidTestEnabled &&
                            <td className='border'>
                              {propertyItem.midTestQuestionNos?.length > 0 && propertyItem.midTestQuestionNos.map((qNo, index, arr) => {
                                return (
                                  <span key={'midQ'+ index}>{qNo + `${index < arr.length - 1 ? ', ' : ''}`}</span>
                                );
                              })}
                            </td>
                          }
                          <td className='border'>
                            {propertyItem.postTestQuestionNos?.length > 0 && propertyItem.postTestQuestionNos?.map((qNo, index, arr) => {
                              return (
                                <span key={'postQ'+ index}>{qNo + `${index < arr.length - 1 ? ', ' : ''}`}</span>
                              );
                            })}
                          </td>
                          <td key={'s'+index} className='border'>{item.scoreType == 'points' ? 'Points' : '%'}</td>
                          {persistData.studentID > 0 &&
                            generateTableRows(`${item.scoreType == 'points' ? 'bg-student-points' : 'bg-student-percentage'}`, item.studentGrowth, thresholdValue, persistData.growth, isMidTestEnabled, isPercent)
                          }
                          {persistData.classID > 0 &&
                            generateTableRows(`${item.scoreType == 'points' ? 'bg-class-points' : 'bg-class-percentage'}`, item.classGrowth, thresholdValue, persistData.growth, isMidTestEnabled, isPercent)
                          }
                          {persistData.teacherID > 0 &&
                            generateTableRows(`${item.scoreType == 'points' ? 'bg-teacher-points' : 'bg-teacher-percentage'}`, item.teacherGrowth, thresholdValue, persistData.growth, isMidTestEnabled, isPercent)
                          }
                          {persistData.schoolID > 0 &&
                            generateTableRows(`${item.scoreType == 'points' ? 'bg-school-points' : 'bg-school-percentage'}`, item.schoolGrowth, thresholdValue, persistData.growth, isMidTestEnabled, isPercent)
                          }
                          {persistData.districtID > 0 &&
                            generateTableRows(`${item.scoreType == 'points' ? 'bg-district-points' : 'bg-district-percentage'}`, item.districtGrowth, thresholdValue, persistData.growth, isMidTestEnabled, isPercent)
                          }
                        </tr>
                        }
                      </React.Fragment>
                    );
                  })}
                </React.Fragment>);
            })}
          </tbody>
        </table>
      </div>
      <Modals
        isOpen={openStandardModal}
        onClose={() => setOpenStandardModal(false)}
        details={viewStandardDetails}
      />
    </>
  );
};

PropertiesTable.propTypes = {
  header: PropTypes.string,
  data: PropTypes.array,
  persistData: PropTypes.object
};

export default PropertiesTable;